<template>
  <svg width="20"
       height="20"
       viewBox="0 0 20 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M5.81641 19.4629C6.31738 19.4629 6.68652 19.2168 7.29297 18.6807L10.3076 16.0264H15.5986C18.2441 16.0264 19.7295 14.4971 19.7295 11.8867V5.05762C19.7295 2.44727 18.2441 0.917969 15.5986 0.917969H4.39258C1.75586 0.917969 0.261719 2.44727 0.261719 5.05762V11.8867C0.261719 14.5059 1.7998 16.0264 4.33105 16.0264H4.69141V18.1797C4.69141 18.9619 5.10449 19.4629 5.81641 19.4629ZM6.25586 17.4941V14.9893C6.25586 14.4707 6.02734 14.2686 5.53516 14.2686H4.4541C2.80176 14.2686 2.01074 13.4336 2.01074 11.834V5.11035C2.01074 3.51074 2.80176 2.67578 4.4541 2.67578H15.5459C17.1895 2.67578 17.9805 3.51074 17.9805 5.11035V11.834C17.9805 13.4336 17.1895 14.2686 15.5459 14.2686H10.2109C9.6748 14.2686 9.41113 14.3564 9.04199 14.7432L6.25586 17.4941ZM5.84277 7.58887C5.84277 8.57324 6.4668 9.33789 7.43359 9.33789C7.81152 9.33789 8.17188 9.25 8.40039 8.97754H8.50586C8.22461 9.64551 7.5918 10.1113 6.9502 10.2695C6.65137 10.3486 6.5459 10.4893 6.5459 10.7002C6.5459 10.9287 6.73926 11.0957 6.99414 11.0957C7.9082 11.0957 9.5957 10.0059 9.5957 7.94043C9.5957 6.73633 8.83105 5.80469 7.6709 5.80469C6.625 5.80469 5.84277 6.54297 5.84277 7.58887ZM10.4658 7.58887C10.4658 8.57324 11.0898 9.33789 12.0566 9.33789C12.4434 9.33789 12.8037 9.25 13.0322 8.97754H13.1289C12.8477 9.64551 12.2148 10.1113 11.5732 10.2695C11.2832 10.3486 11.1777 10.4893 11.1777 10.7002C11.1777 10.9287 11.3623 11.0957 11.6172 11.0957C12.5312 11.0957 14.2188 10.0059 14.2188 7.94043C14.2188 6.73633 13.4541 5.80469 12.2939 5.80469C11.248 5.80469 10.4658 6.54297 10.4658 7.58887Z"
          :fill="color"/>
  </svg>
</template>
<script>
export default {
  name: 'EmailIcon',
  props: {
    width: {
      type: Number,
      default: 256
    },
    height: {
      type: Number,
      default: 256
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
